<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="lock_icon_modal"
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="54"
    viewBox="0 0 54 54"
  >
    <path id="Path_8430" data-name="Path 8430" d="M0,0H54V54H0Z" fill="none" />
    <path
      id="Path_8431"
      data-name="Path 8431"
      d="M11.25,14.381h9a2.257,2.257,0,0,1,2.25,2.25V23.5a2.251,2.251,0,0,1-2.25,2.25h-9A2.251,2.251,0,0,1,9,23.5V16.631a2.251,2.251,0,0,1,2.25-2.25Zm.711,0V11.539a3.789,3.789,0,0,1,7.578,0v2.837"
      transform="translate(11.25 9.688)"
      fill="none"
      :stroke="clr ? clr : '#ec484a'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
    <path
      id="Path_8432"
      data-name="Path 8432"
      d="M19.82,43.219A20.261,20.261,0,1,0,3.283,26.679,20.276,20.276,0,0,0,19.82,43.219Z"
      transform="translate(3.751 3.75)"
      fill="none"
      :stroke="clr ? clr : '#ec484a'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
  </svg>
</template>
